import * as Yup from 'yup';

const boardLogSchema = Yup.object({
    start_date: Yup.string()
        // .test('dob', 'Invalid start date', function (value) {
        //     return value && !isNaN(new Date(value).getTime());
        // })
        .nullable()
        .notRequired(),
    end_date: Yup.string()
        .nullable()
        .test(
            'is-greater',
            'End date cannot be earlier than the start date',
            function (value) {
                const { start_date } = this.parent;
                return new Date(value) >= new Date(start_date);
            }
        )
        // .test('dob', 'Invalid end date', function (value) {
        //     return value && !isNaN(new Date(value).getTime());
        // })
        .notRequired(),
    uuid_board: Yup.array()
        .notRequired()
});

export default boardLogSchema;